import React from "react";
import RectBG from "../images/Right_RectBG.svg";
// import RightImg from "../images/Right_img.svg";
import RightImg from "../images/Yash_Img.svg";
import { ReactComponent as Rarr } from "../images/rarr.svg";
// import { AnimatePresence, motion } from "framer-motion";

export default function Landing() {
  return (
    <div className="container landing-md mb-5" id="home">
      <div className="left-side">
        <div className="intro">
          <h1 className="intro_1">hey everyone,</h1>
          <h1 className="intro_2">i am yash</h1>
          <div className="sub-intro">
            <h1 className="intro_3">Frontend Developer,</h1>
            <h1 className="intro_4">Gaming Enthusiast & a student.</h1>
          </div>
          <a href="#contact" className="btn hire_me">
            HIRE ME <Rarr />
          </a>
        </div>
      </div>
      <div
        initial={{ x: 1000 }}
        animate={{ x: 0 }}
        transition={{ duration: 0.4, ease: "easeOut" }}
        className="right_side"
      >
        <img src={RectBG} alt="Right_BG" />
        <div className="img-right">
          <img src={RightImg} alt="right_image" />
        </div>
      </div>
    </div>
  );
}
